enum TemperatureScale {
  CELSIUS = "celsius",
  FAHRENHEIT = "fahrenheit",
}

export default TemperatureScale
